import { library } from '@fortawesome/fontawesome-svg-core'

import { faCoffee } from '@fortawesome/free-solid-svg-icons/faCoffee'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog'
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter'
import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons/faFileInvoiceDollar'
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faTimes as farTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint'
import { faFolder } from '@fortawesome/free-solid-svg-icons/faFolder'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons/faMinusSquare'
import { faColumns } from '@fortawesome/free-solid-svg-icons/faColumns'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons/faLongArrowAltRight'
import { faRocket } from '@fortawesome/free-solid-svg-icons/faRocket'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons/faEllipsisV'
import { faListUl } from '@fortawesome/free-solid-svg-icons/faListUl'
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons/faFileInvoice'
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons/faShoppingBag'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine'
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage'
import { faGripVertical } from '@fortawesome/free-solid-svg-icons/faGripVertical'
import { faPen } from '@fortawesome/pro-duotone-svg-icons/faPen'
import { faAlarmClock } from '@fortawesome/pro-duotone-svg-icons/faAlarmClock'
import { faExternalLink as fadExternalLink } from '@fortawesome/pro-duotone-svg-icons/faExternalLink'
import { faExternalLink as fasExternalLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink'
import { faSave } from '@fortawesome/pro-solid-svg-icons/faSave'
import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons/faCalendarStar'
import { faHandHoldingUsd } from '@fortawesome/pro-solid-svg-icons/faHandHoldingUsd'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { faLocation } from '@fortawesome/pro-solid-svg-icons/faLocation'
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons/faSpinnerThird'
import { faEdit as fadEdit } from '@fortawesome/pro-duotone-svg-icons/faEdit'
import { faCopy as fadCopy } from '@fortawesome/pro-duotone-svg-icons/faCopy'
import { faHouseReturn as fasHouseReturn } from '@fortawesome/pro-solid-svg-icons/faHouseReturn'
import { faLaptopHouse as fasLaptopHouse } from '@fortawesome/pro-solid-svg-icons/faLaptopHouse'
import { faEuroSign as farEuroSign } from "@fortawesome/pro-regular-svg-icons/faEuroSign"
import { faHouseUser as fasHouseUser } from "@fortawesome/pro-solid-svg-icons/faHouseUser"
import { faExclamationTriangle as fasExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle"
import { faStore as fadStore } from "@fortawesome/pro-duotone-svg-icons/faStore"
import { faDoNotEnter as fadDoNotEnter } from "@fortawesome/pro-duotone-svg-icons/faDoNotEnter"
import { faTimesCircle as fadTimesCircle } from "@fortawesome/pro-duotone-svg-icons/faTimesCircle"
import { faCheckCircle as fadCheckCircle } from "@fortawesome/pro-duotone-svg-icons/faCheckCircle"
import { faRocketLaunch } from "@fortawesome/pro-solid-svg-icons/faRocketLaunch"
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle"
import { faCopy } from "@fortawesome/pro-solid-svg-icons/faCopy"
import { faUserCircle as fadUserCircle } from "@fortawesome/pro-duotone-svg-icons/faUserCircle"
import { faUser as fadUser } from "@fortawesome/pro-duotone-svg-icons/faUser"
import { faSignOut as fadSignOut } from "@fortawesome/pro-duotone-svg-icons/faSignOut"
import { faBell } from "@fortawesome/pro-solid-svg-icons/faBell"
import { faChevronLeft as farChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft"
import { faSearch as farSearch } from "@fortawesome/pro-regular-svg-icons/faSearch"
import { faCommentLines as farCommentLines } from "@fortawesome/pro-regular-svg-icons/faCommentLines"

library.add(
    faCoffee,
    faChevronDown,
    faUserCircle,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCog,
    faFilter,
    faCalendar,
    faShoppingCart,
    faFileInvoiceDollar,
    faQuestion,
    faPlus,
    faMinus,
    faInfoCircle,
    faCheck,
    faTimes,
    faTrash,
    faPrint,
    faFolder,
    faSpinner,
    faMinusSquare,
    faColumns,
    faEye,
    faLink,
    faEdit,
    faLongArrowAltRight,
    faRocket,
    faSearch,
    faEllipsisV,
    faListUl,
    faShoppingBag,
    faFileInvoice,
    faEnvelope,
    faChartLine,
    faImage,
    faGripVertical,
    faPen,
    faAlarmClock,
    faHandHoldingUsd,
    faUsers,
    fadExternalLink,
    faCalendarStar,
    fasExternalLink,
    faSave,
    faLocation,
    fadEdit,
    farTimes,
    faSpinnerThird,
    fadCopy,
    fasHouseReturn,
    fasLaptopHouse,
    farEuroSign,
    fasHouseUser,
    fasExclamationTriangle,
    fadStore,
    fadDoNotEnter,
    fadTimesCircle,
    fadCheckCircle,
    faRocketLaunch,
    faQuestionCircle,
    faCopy,
    fadUserCircle,
    fadUser,
    fadSignOut,
    faBell,
    farChevronLeft,
    farSearch,
    farCommentLines
);
